<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-3">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">
                Purchase Translation Words
              </h1>
              <h1 class="text-lead text-primary">TEST</h1>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div id="prices" class="container mt--7 pb-5" styie="width: 980px;">
      <div class="row justify-content-center">
        <div class="col text-center">
          <h1 class="text-white">{{ memberType }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col" v-for="unit in currentUnitList" :key="unit.id">
          <card
            header-classes="bg-transparent"
            body-classes="px-lg-7"
            class="card-pricing border-0 text-center mb-4"
            style="height: 96%;"
          >
            <h2
              slot="header"
              class="text-uppercase ls-1 text-primary py-0 mb-0"
            >
              {{ unit.name }}
            </h2>
            <div class="display-3">₩{{ unit.priceText }}</div>
            <span class="text-muted">{{ unit.pages }}page</span>
            <ul class="list-unstyled my-1">
              <li>
                <div class="d-flex align-items-center">
                  <div>
                    <div
                      class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                    >
                      <i class="fas fa-gift"></i>
                    </div>
                  </div>
                  <div class="w-100">
                    <span class="pl-2">+ {{unit.name}} (24.9.30 까지)</span>
                  </div>
                </div>
              </li>
            </ul>
            <div slot="footer" href="#!" class="text-light text-center">
              <base-button type="primary" @click="onSubmit(unit)">
                Purchase
              </base-button>
            </div>
          </card>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col text-center">
          <h2 class="text-light">{{ otherMemberType }}</h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col" v-for="unit in otherUnitList" :key="unit.id">
          <card
            header-classes="bg-transparent"
            body-classes="px-lg-7"
            class="card-pricing border-0 text-center mb-4"
            style="height: 96%;"
          >
            <h2
              slot="header"
              class="text-uppercase ls-1 text-primary py-0 mb-0"
            >
              {{ unit.name }}
            </h2>
            <div class="display-3">₩{{ unit.priceText }}</div>
            <span class="text-muted">{{ unit.pages }}page</span>
            <ul class="list-unstyled my-1">
              <li>
                <div class="d-flex align-items-center">
                  <div>
                    <div
                      class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white"
                    >
                      <i class="fas fa-gift"></i>
                    </div>
                  </div>
                  <div class="w-100">
                    <span class="pl-2">+ {{unit.name}} (24.9.30 까지)</span>
                  </div>
                </div>
              </li>
            </ul>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BootPay from "bootpay-js"
import { mapGetters } from 'vuex'
import { v4 as uuid } from 'uuid'

export default {
  data() {
    return {
      result: '',
      message: '',
      units: {},
    }
  },
  computed: {
    ...mapGetters(['isLawTimes', 'isLawTimesSubscriber']),
    memberType() {
      return '일반 회원'
    },
    otherMemberType() {
      return !this.isLawTimesSubscriber ? '법률신문 구독 회원(70% 할인)' : '법률신문 일반 회원'
    },
    currentUnitList() {
      return this.units.test
    },
    otherUnitList() {
      return []
    }
  },
  async created() {
    console.log('Purchase created.', this.$store.state.uid)
    console.log(this.$store.getters.isLawTimes)
  },
  async mounted() {
    const { data } = await this.$slowbro.get('/payment/lawtimes-units')
    this.units = data
    console.log('units', this.units)
  },
  methods: {
    async back() {
      await this.$router.replace('/')
    },
    async onSubmit(unit) {
      console.log('unit', unit, 'uid', this.$store.state.uid)
      console.log('store', this.$store.state)
      if (!this.$store.state.uid) {
        this.$swal.fire({
          title: 'Please login',
          message: 'You need to login to purchase.',
          type: 'warning',
        })
        return
      }
      //실제 복사하여 사용시에는 모든 주석을 지운 후 사용하세요
      BootPay.request({
        price: unit.price, //실제 결제되는 가격
        application_id: '6221be0f270180001ef67313',
        name: `OTran ${unit.words} words`, //결제창에서 보여질 이름
        pg: 'kcp',
        method: 'card', //결제수단, 입력하지 않으면 결제수단 선택부터 화면이 시작합니다.
        show_agree_window: 0, // 부트페이 정보 동의 창 보이기 여부
        items: [
          {
            item_name: unit.name, //상품명
            qty: 1, //수량
            unique: 'otran_lawtimes_' + unit.id, //해당 상품을 구분짓는 primary key
            price: unit.price, //상품 단가
            cat1: 'unit', // 대표 상품의 카테고리 상, 50글자 이내
          }
        ],
        user_info: {
          username: '사용자 이름',
          email: '사용자 이메일',
          addr: '사용자 주소',
          phone: '010-1234-4567'
        },
        order_id: `unit_${unit.id}_${uuid().split('-').join('')}`, //고유 주문번호로, 생성하신 값을 보내주셔야 합니다.
        params: {
          user_uid: this.$store.state.uid,
          user_id: this.$store.state.id,
          amount: unit.amount,
          unit: unit
        },
        account_expire_at: '2030-01-01', // 가상계좌 입금기간 제한 ( yyyy-mm-dd 포멧으로 입력해주세요. 가상계좌만 적용됩니다. )
        extra: {
          start_at: '2019-05-10', // 정기 결제 시작일 - 시작일을 지정하지 않으면 그 날 당일로부터 결제가 가능한 Billing key 지급
          end_at: '2024-05-10', // 정기결제 만료일 -  기간 없음 - 무제한
          vbank_result: 1, // 가상계좌 사용시 사용, 가상계좌 결과창을 볼지(1), 말지(0), 미설정시 봄(1)
          quota: '0,2,3', // 결제금액이 5만원 이상시 할부개월 허용범위를 설정할 수 있음, [0(일시불), 2개월, 3개월] 허용, 미설정시 12개월까지 허용,
          theme: 'custom', // [ red, purple(기본), custom ]
          custom_background: '#139c7e', // [ theme가 custom 일 때 background 색상 지정 가능 ]
          custom_font_color: '#ffffff' // [ theme가 custom 일 때 font color 색상 지정 가능 ]
        }
      }).error(function (data) {
        //결제 진행시 에러가 발생하면 수행됩니다.9
        console.log('Error', data);
      }).cancel(function (data) {
        //결제가 취소되면 수행됩니다.
        console.log('Candel', data);
      }).ready(function (data) {
        // 가상계좌 입금 계좌번호가 발급되면 호출되는 함수입니다.
        console.log('Virtual Account', data);
      }).confirm(function (data) {
        //결제가 실행되기 전에 수행되며, 주로 재고를 확인하는 로직이 들어갑니다.
        //주의 - 카드 수기결제일 경우 이 부분이 실행되지 않습니다.
        console.log('Before Payment', data);
        let enable = true; // 재고 수량 관리 로직 혹은 다른 처리
        if (enable) {
          BootPay.transactionConfirm(data); // 조건이 맞으면 승인 처리를 한다.
        } else {
          BootPay.removePaymentWindow(); // 조건이 맞지 않으면 결제 창을 닫고 결제를 승인하지 않는다.
        }
      }).close(function (data) {
        // 결제창이 닫힐때 수행됩니다. (성공,실패,취소에 상관없이 모두 수행됨)
        console.log('close', data, this);
      }).done(function (data) {
        //결제가 정상적으로 완료되면 수행됩니다
        //비즈니스 로직을 수행하기 전에 결제 유효성 검증을 하시길 추천합니다.
        console.log('done', data);
      });
    },
  },
  watch: {

  },
}
</script>
<style lang="scss">
.price-col {
  min-width: 200px;
  width: 32%;
  max-width: 370px;
  min-height: 1px;
  padding: 1.5rem 7rem;
  margin: 2px;
  background-color: white;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
